var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgQuestionCircle = function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3726 12.112C10.3726 11.5573 10.4953 11.0987 10.7406 10.736C10.9966 10.3733 11.3646 9.97333 11.8446 9.536C12.1966 9.216 12.4526 8.94933 12.6126 8.736C12.7833 8.512 12.8686 8.26133 12.8686 7.984C12.8686 7.58933 12.7086 7.28 12.3886 7.056C12.0793 6.82133 11.6633 6.704 11.1406 6.704C10.6393 6.704 10.1913 6.81067 9.79661 7.024C9.41261 7.22667 9.08727 7.51467 8.82061 7.888L6.88461 6.752C7.33261 6.06933 7.93527 5.54133 8.69261 5.168C9.46061 4.79467 10.3673 4.608 11.4126 4.608C12.6393 4.608 13.6206 4.86933 14.3566 5.392C15.1033 5.91467 15.4766 6.64 15.4766 7.568C15.4766 8.00533 15.4019 8.38933 15.2526 8.72C15.1139 9.05067 14.9379 9.33333 14.7246 9.568C14.5219 9.792 14.2553 10.0533 13.9246 10.352C13.5299 10.704 13.2419 11.0027 13.0606 11.248C12.8793 11.4827 12.7886 11.7707 12.7886 12.112H10.3726ZM11.5886 16.128C11.1513 16.128 10.7833 15.9893 10.4846 15.712C10.1966 15.424 10.0526 15.0773 10.0526 14.672C10.0526 14.2667 10.1966 13.9307 10.4846 13.664C10.7726 13.3867 11.1406 13.248 11.5886 13.248C12.0366 13.248 12.4046 13.3867 12.6926 13.664C12.9806 13.9307 13.1246 14.2667 13.1246 14.672C13.1246 15.0773 12.9753 15.424 12.6766 15.712C12.3886 15.9893 12.0259 16.128 11.5886 16.128Z",
    fill: "#979797"
  })));
};

export default __webpack_public_path__ + "static/media/question-circle.b9de4f97.svg";
export { SvgQuestionCircle as ReactComponent };